import { CascaderOptionType } from 'antd/lib/cascader'

export const searchOptionsFilter = (inputValue: string, path: CascaderOptionType[]): boolean => {
  return path.some((option: CascaderOptionType) => {
    const label: string | undefined = !!option.label ? (option.label as string) : undefined
    return label ? label.toLowerCase().includes(inputValue.toLowerCase()) : false
  })
}

export const cascaderOptionsHaveNestedLevel = (options: CascaderOptionType[]): boolean =>
  options.some((option) => Array.isArray(option.children) && option.children.length > 0)

